import React, { useCallback } from 'react';
import './OverviewStatCards.css';

export function overviewMoneyValue(value) {
  const amount = Math.round(Number(value) || 0).toLocaleString();
  return (
    <span className="overview-stat-card__money">
      <span className="overview-stat-card__money-currency">Tsh</span>
      <span className="overview-stat-card__money-amount">{amount}</span>
    </span>
  );
}

export function overviewDamagedStack({ accepted = 0, rejected = 0, pending = 0 }) {
  return (
    <div className="overview-stat-card__damaged-stack">
      <div className="overview-stat-card__damaged-row">
        <span className="overview-stat-card__damaged-num">{accepted}</span>
        <span className="overview-stat-card__damaged-label">accepted</span>
      </div>
      <div className="overview-stat-card__damaged-row">
        <span className="overview-stat-card__damaged-num">{rejected}</span>
        <span className="overview-stat-card__damaged-label">rejected</span>
      </div>
      <div className="overview-stat-card__damaged-row">
        <span className="overview-stat-card__damaged-num">{pending}</span>
        <span className="overview-stat-card__damaged-label">pending</span>
      </div>
    </div>
  );
}

/**
 * Overview KPI cards — sample-style with left accent, top-right glow, centered values.
 */
export default function OverviewStatCards({ cards, onCardClick }) {
  const onKeyActivate = useCallback(
    (card) => (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onCardClick?.(card);
      }
    },
    [onCardClick]
  );

  return (
    <div className="overview-stat-cards">
      {cards.map((card) => (
        <div
          key={card.id}
          className={[
            'overview-stat-card',
            `overview-stat-card--${card.border || 'blue'}`,
            'overview-stat-card--clickable',
            'overview-stat-card--glow',
            card.isMoney ? 'overview-stat-card--money' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          role="link"
          tabIndex={0}
          title={card.hint}
          onClick={() => onCardClick?.(card)}
          onKeyDown={onKeyActivate(card)}
        >
          <div className="overview-stat-card__title">{card.title}</div>
          {card.caption ? <div className="overview-stat-card__caption">{card.caption}</div> : null}
          <div className="overview-stat-card__value">{card.value}</div>
        </div>
      ))}
    </div>
  );
}
